<main class="d-flex flex-column" *ngIf="ready$ | async">
    <div class="app-alert hide--md" *ngIf="alert"><div class="container">{{alert}}</div></div>
    <app-header *ngIf="true"></app-header>
    <div class="app-alert show--md" *ngIf="alert"><div class="container">{{alert}}</div></div>
    <div class="flex-grow-1"><router-outlet></router-outlet></div>
    <app-footer *ngIf="true"></app-footer>
</main>
<!-- <div [ngClass]="darkMode ? 'theme--dark' : 'theme--light'" class="background"></div> -->